module.exports = __webpack_public_path__ + "img/pm3.8bfeded9.png";